<template>
  <div
      class="min-h-full flex items-center justify-center bg-gradient-to-br from-background via-background/80 to-background/60 px-4 sm:px-6 transition-all duration-500 relative">
    <div class="fixed top-4 right-4">
      <ThemeToggle class="absolute top-0 right-0"/>
    </div>
    <div class="w-full max-w-md transform transition-all duration-500 ease-out login-container">
      <div
          class="bg-card/95 backdrop-blur-sm rounded-2xl shadow-xl dark:shadow-2xl overflow-hidden p-8 hover:shadow-2xl transition-all duration-500 border border-border login-card">
        <div class="text-center mb-8 transform transition-all duration-300">
          <a href="https://onlstreet.com" target="_blank" class="">
            <img class="w-3/4 mx-auto" src="@/assets/img/logo-onlstreet.png" alt="Logo Onlstreet">
          </a>
          <p class="text-base text-muted-foreground mt-4 animate-fade-in leading-5">Vui lòng
            đăng nhập bằng tài khoản
            Onlstreet để tham gia chương trình.</p>
          <!--          <p v-else-if="user.Name">Xin chào, {{ user.Name }}</p>-->
          <!--          <p v-else-if="user.Phone">Xin chào, {{ user.Name }}</p>-->
          <!--          <div v-else></div>-->
        </div>

        <LoginSteps :current-step="currentStep" v-show="currentStep != 1"/>

        <div class="mt-6">
          <LoginForm
              :current-step="currentStep"
              @next-step="handleNextStep"
          />
        </div>
      </div>

      <div class="text-center mt-8 text-sm text-muted-foreground font-bold">
        &copy; {{ new Date().getFullYear() }} Onlstreet
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref, onMounted, nextTick} from 'vue';
import LoginSteps from '@/components/Login/LoginSteps.vue';
import LoginForm from '@/components/Login/LoginForm.vue';
import ThemeToggle from '@/components/ThemeToggle.vue';
import {useLoading} from '@/composables/useLoading';
import {useImageLoading} from '@/composables/useImageLoading';

// Use your Vue-specific toast implementation or adapt useToast
const currentStep = ref(1);

const handleNextStep = (step: number) => {
  currentStep.value = Math.min(step, 3);
};

onMounted(() => {
  // Wait for all images to be loaded before hiding the loading overlay
  const {waitForImages} = useImageLoading();
  const {stopLoading} = useLoading();

  // Use nextTick to ensure the DOM is updated with the new data
  nextTick(async () => {
    // Wait for all images to be loaded
    await waitForImages();
    // Then hide the loading overlay
    stopLoading();
  });
});
</script>

<style scoped>
.login-container {
  animation: login-container-appear 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}

.login-card {
  animation: login-card-appear 0.8s cubic-bezier(0.22, 1, 0.36, 1);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  will-change: transform, opacity, box-shadow;
}

.login-card:hover {
  box-shadow: 0 15px 35px color-mix(in srgb, var(--primary) 15%, transparent), 0 5px 15px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
}

@keyframes login-container-appear {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes login-card-appear {
  0% {
    opacity: 0;
    transform: scale(0.9) translateY(30px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(0);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(8px);
  }
}

/* Enhance form transitions */
.mt-6 {
  animation: form-appear 0.9s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes form-appear {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  30% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
